import React from 'react'

const Banner = () => {
    return (
        <div className=" p-3  bg-[#132C4D]  text-center flex flex-col items-center justify-center" >
            <h3 className="md:text-2xl sm:text-xl text-lg text-[#fdf651] font-bold ">
                IMPORTANT: Do NOT close this window nor click the “Back” button
            </h3>
            <p className='text-[#fdf651] md:text-xl text-base'>
                Clicking “back” button can result in your order being double-billed
            </p>
        </div>
    )
}

export default Banner
